import { React } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { emailRegex, formatPhoneNumber, logout, setAuthToken } from '../common';
import PmsUrlConfig from '../../urlConfig';
import BasicUserSettings from './BasicUserSettings';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import ErrorMessages from '../../errorConfig';
import pmsConstants from '../../pmsConstants';

export default function StaffBasicUserSettings() {
    const practiceDetails = useSelector(state => state.practiceDetails);
    const loginDetails = useSelector(state => state.loginDetails);
    const dispatch = useDispatch();
    if (!practiceDetails)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const practice = practiceDetails.practice;
    if (!practice)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    var loggedInUser = null;
    var userType = "";
    var token = "";
    if (loginDetails != null) {
        loggedInUser = loginDetails.loggedInUser;
        userType = loggedInUser.user_type;
        token = loginDetails.jwtToken;
    }

    const BasicDetailsSchema = Yup.object().shape({
        firstname: Yup.string().required(ErrorMessages.FIRSTNAME_REQUIRED),
        lastname: Yup.string().required(ErrorMessages.LASTNAME_REQUIRED),
        userEmail: Yup.string()
            .required(ErrorMessages.EMAIL_REQUIRED)
            .matches(emailRegex, ErrorMessages.EMAIL_INVALID),
        phoneNo: Yup.string().required(ErrorMessages.PHONE_NUM_REQUIRED),

    })
    var formattedPhoneNum = "";

    formattedPhoneNum = formatPhoneNumber(loggedInUser.phoneNum);
    const successMsg = practiceDetails.successMsg;
    const errorMsg = practiceDetails.errorMsg;

    return (
        <div>
            <Formik
                initialValues={{
                    firstname: loggedInUser.firstname,
                    lastname: loggedInUser.lastname,
                    username: loggedInUser.username,
                    userEmail: loggedInUser.email,
                    phoneNo: formattedPhoneNum
                }}
                validationSchema={BasicDetailsSchema}
                onSubmit={(values, { setSubmitting }) => {
                    var userUpdateObj;
                    var editUserUrl = PmsUrlConfig.BOS_EDIT_USER_URL;
                    userUpdateObj = {
                        _id: loggedInUser._id,
                        firstname: values.firstname,
                        lastname: values.lastname,

                        email: values.userEmail,
                        phoneNum: values.phoneNo.replace(/[^\d]/g, ''),

                        password: loggedInUser.password,
                        password_confirm: loggedInUser.password,
                        user_type: loggedInUser.user_type,
                        active_user: (loggedInUser.active_user),
                    }

                    setAuthToken(token);
                    Axios.post(editUserUrl, userUpdateObj
                    ).then((response) => {
                        if (response.status === 200) {

                            dispatch({
                                type: 'basicSettingsUpdateSuccess',
                                payload: response.data
                            })
                            dispatch({
                                type: 'loginSuccess',
                                payload: response.data
                            })
                            setSubmitting(false);
                        }
                        else if (response.status === 400) {
                            console.log("STATUS 400:", response)
                            setSubmitting(false);
                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        console.log("ERROR:", error)
                        setSubmitting(false);
                    })
                }}

            >
                {({ errors, touched, values, handleChange, setFieldValue, handleBlur, isSubmitting }) => (
                    <Form id="update_basic_settings_form">
                        <Container fluid className="basic-settings col-10 align-item-center">
                            {successMsg && <div className='success_msg_div'>{successMsg}</div>}
                            {errorMsg && <div className='error_msg_div'>{errorMsg}</div>}
                            <BasicUserSettings
                                errors={errors}
                                touched={touched}
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isEditPage="true"
                                userType={userType}
                                patientEdit={userType === pmsConstants.USER_TYPE_PATIENT}
                            />

                            <Row>
                                <Col>
                                    <button 
                                        type="submit" 
                                        disabled={isSubmitting}
                                        className="px-8 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] disabled:bg-gray-400 text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2 min-w-[120px]"
                                    >
                                        {isSubmitting ? "Saving..." : "Save"}
                                    </button>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

